<template>
    <v-container fluid>
        <v-row>
            <sarala-table
                :model="model"
                :createRoute="{
                    name: 'rule.create',
                    params: {
                        category_id: categoryId,
                    },
                    query: { cycle_rule: '1' },
                }"
                :resourceName="$tc('resources.cycle_rule.name', 1)"
                :query="categoryFilter"
                ref="table"
            >
                <template #max_value="{ item }">
                    {{ item.max_value ? item.max_value : '∞' }}
                </template>

                <template #percentage="{ item }">
                    {{ $n(item.percentage / 100, 'percent') }}
                </template>

                <template #action="{ item }">
                    <edit-btn
                        :to="{
                            name: 'rule.edit',
                            params: { id: item.id, category_id: categoryId },
                            query: { cycle_rule: '1' },
                        }"
                    />

                    <delete-btn @click="deleteItem(item)" />
                </template>
            </sarala-table>
        </v-row>
        <confirm-delete ref="confirmDelete" />
    </v-container>
</template>

<script>
import SaralaTable from '@/shared/components/SaralaTable'
import CycleRule from '@/models/CycleRule'

export default {
    props: ['categoryId'],

    components: {
        SaralaTable,
    },

    computed: {
        model() {
            return new CycleRule()
        },
    },

    methods: {
        async deleteItem(item) {
            let confirmed = await this.$refs.confirmDelete.confirm(
                `${item.min_value}-${item.max_value || '∞'} clientes (${
                    item.percentage
                }%)`,
            )
            if (!confirmed) return

            await item.delete()

            this.$refs.table.getItems()

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('resources.feedbacks.success.delete', {
                    resource: this.$tc('resources.cycle_rule.name'),
                }),
            )
        },

        categoryFilter(model) {
            model
                .where('category_id', this.categoryId)
                .where('cycle_rules', true)
        },
    },
}
</script>

<style></style>
